import React from "react";

// Helper function to render children (handles text, bold text, and links)
const renderChildren = (children) => {
  return children.map((child, childIdx) => {
    // Handle link type
    if (child.type === "link") {
      return (
        <a
          key={childIdx}
          href={child.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {child.children.map((linkChild) => linkChild.text).join("")}
        </a>
      );
    }
    // Handle bold text
    if (child.bold) {
      return <strong key={childIdx}>{child.text}</strong>;
    }
    // Handle regular text
    return <span key={childIdx}>{child.text}</span>;
  });
};

// Strapi content rendering utilities
export const renderStrapiContent = (content) => {
  if (!content) return null;
  // If content is a string, render it as plain text
  // Note: If you need to render HTML, consider using a sanitization library like DOMPurify
  if (typeof content === "string") {
    return <div>{content}</div>;
  }

  // If content is an array of blocks (Strapi rich text format)
  if (Array.isArray(content)) {
    return content.map((block, index) => {
      switch (block.type) {
        case "paragraph":
          return <p key={index}>{renderChildren(block.children)}</p>;
        case "heading":
          const HeadingTag = `h${block.level}`;
          return (
            <HeadingTag key={index}>
              {renderChildren(block.children)}
            </HeadingTag>
          );
        case "list":
          const ListTag = block.format === "ordered" ? "ol" : "ul";
          return (
            <ListTag key={index}>
              {block.children.map((item, itemIndex) => (
                <li key={itemIndex}>{renderChildren(item.children)}</li>
              ))}
            </ListTag>
          );
        case "image":
          const { image, caption } = block;
          return (
            <figure key={index}>
              <img
                className="p-5 p-l-0"
                src={image.url}
                alt={image.alternativeText || image.name}
                height={image.formats.small.height}
              />
              {caption && <figcaption>{caption}</figcaption>}
            </figure>
          );
        default:
          return <div key={index}>{JSON.stringify(block)}</div>;
      }
    });
  }

  return null;
};
